import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon, IconColor, IconName, IconSize } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { setTooltip } from '@as-react/common-utils';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getDeliveryExplanation } from '../../../util/DeliveryPromiseUtil';
import DeliveryPromiseMessage from '../delivery-promise/DeliveryPromiseMessage';
const tooltipOptionsOverride = {
    placement: 'top',
    popperOptions: {
        positionFixed: true,
    },
};
export const MiniPDPDeliveryPromise = ({ deliveryPromise, deliveryPromiseExplanations, boxProps, }) => {
    var _a, _b;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { feature_toggles } = useAemConfig();
    const deliveryPromises = (_b = (_a = deliveryPromise === null || deliveryPromise === void 0 ? void 0 : deliveryPromise.deliveryPromises) === null || _a === void 0 ? void 0 : _a.filter(deliveryPromise => deliveryPromise.deliveryMessage)) !== null && _b !== void 0 ? _b : [];
    const deliveryPromiseExplanation = getDeliveryExplanation(deliveryPromise, deliveryPromiseExplanations);
    const setTranslationKey = (name) => name ? `pdp.deliverypromise.${name.toLowerCase()}.txt` : 'pdp.deliverypromise.home_delivery.txt';
    const setTooltipElement = () => {
        if (deliveryPromiseExplanation && deliveryPromises.length > 0) {
            deliveryPromises.map((_, index) => setTooltip({
                element: `#mini-pdp-delivery-item-explanation-${index}`,
                content: deliveryPromiseExplanation,
                showCloseButton: false,
                optionsOverride: tooltipOptionsOverride,
            }));
        }
    };
    useEffect(() => {
        setTooltipElement();
    }, [deliveryPromiseExplanation]);
    return (_jsxs(Box, Object.assign({}, boxProps, { testId: "delivery_promise", children: [feature_toggles.delivery_promise_select_size_label && !deliveryPromises.length && (_jsxs(_Fragment, { children: [_jsxs(TextAlpha, { variant: "bodyS", strong: true, as: "span", children: [t('pdp.selectsize.prefix.txt'), ' '] }), _jsx(TextAlpha, { variant: "bodyS", as: "span", children: t('pdp.selectsize.txt') })] })), deliveryPromises.map((deliveryPromiseItem, i) => (_jsxs(Box, { paddingBlockEnd: deliveryPromises.length > 1 && i === 0 ? '2' : undefined, children: [feature_toggles.delivery_promise_standard_delivery_label && (_jsx(TextAlpha, { strong: true, color: "success", children: t(setTranslationKey(deliveryPromiseItem.name)).toUpperCase() })), _jsx(DeliveryPromiseMessage, { deliveryPromise: deliveryPromiseItem }), deliveryPromiseExplanation && (_jsxs(_Fragment, { children: [' ', _jsx(Icon, { id: `mini-pdp-delivery-item-explanation-${i}`, size: IconSize.MINOR, color: IconColor.POSITIVE, name: IconName.INFORMATION_OUTLINE, dynamicContent: deliveryPromiseExplanation, inline: true })] }))] }, deliveryPromiseItem.name)))] })));
};
